import { Navigate } from "react-router";
import { useAppAuth } from "@/hooks/useAppAuth";
import { useAdminMode } from "@/contexts/AdminModeContext";

export default function RootRedirect() {
  const { role } = useAppAuth();
  const { adminMode } = useAdminMode();
  const returnTo = sessionStorage.getItem("returnTo");

  if (returnTo && returnTo.startsWith("/")) {
    sessionStorage.removeItem("returnTo");
    return <Navigate to={returnTo} replace />;
  }

  if (role === "member" || adminMode === "member") {
    return <Navigate to="/assistant" replace />;
  }

  return <Navigate to="/documents" replace />;
}
